import React from 'react';
import { isPriceOptionDisabled } from '../../../utils/formOptions';
import {
  buildMinPriceOptions,
  buildMaxPriceOptions,
} from '../../../utils/priceOptionsUtils';

function MobilePriceRangeField({
  maxPriceData,
  minPrice,
  maxPrice,
  onMinPriceChange,
  onMaxPriceChange,
}) {
  const minPriceOptions = buildMinPriceOptions(maxPriceData);
  const maxPriceOptions = buildMaxPriceOptions(maxPriceData);
  return (
    <div>
      <fieldset className="px-4">
        <legend className="block font-medium text-black text-sm mb-3">
          Price
        </legend>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="mobile-min-price"
            >
              Minimum price
            </label>
            <div className="relative">
              <select
                id="mobile-min-price"
                className="px-3 min-h-[42px] text-[#6B7280] bg-grey-100 w-full border border-[#ebebeb] appearance-none rounded"
                value={minPrice}
                onChange={(e) => onMinPriceChange(e.target.value)}
              >
                {minPriceOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={isPriceOptionDisabled(
                      option.value,
                      'min',
                      minPrice,
                      maxPrice
                    )}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                width="10"
                height="7"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[#6B7280]"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="mobile-max-price"
            >
              Maximum price
            </label>
            <div className="relative">
              <select
                id="mobile-max-price"
                className="px-3 min-h-[42px] text-[#6B7280] bg-grey-100 w-full border border-[#ebebeb] appearance-none rounded"
                value={maxPrice}
                onChange={(e) => onMaxPriceChange(e.target.value)}
              >
                {maxPriceOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={isPriceOptionDisabled(
                      option.value,
                      'max',
                      minPrice,
                      maxPrice
                    )}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                width="10"
                height="7"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[#6B7280]"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
}

export default MobilePriceRangeField;
